import React from 'react';
import { useNavigate } from 'react-router-dom';
import DigitalDisplay from '../components/DigitalDisplay';
import './About.css';

const About = () => {
	const navigate = useNavigate();

	return (
		<div className='page-container'>
			<DigitalDisplay>
				{/* About Header */}
				<div className='about-header'>
					<h1 className='about-title'>
						About
						<img
							src='/assets/images/solana_1_dollar_stable_memecoin_270x248px.png'
							alt='$1 Logo'
							className='header-logo'
						/>
					</h1>
				</div>

				{/* Link Tree */}
				<div className='link-tree'>
					<div className='link-item'>
						<a
							href='https://t.me/Onedollarportal'
							target='_blank'
							rel='noopener noreferrer'>
							<img
								src='/assets/icons/1-solana-stable-meme-coin-telegram.png'
								alt='Telegram Icon'
								className='icon'
							/>
							$1 Telegram Portal Link
						</a>
					</div>
					<div className='link-item'>
						<a
							href='https://x.com/1stablememecoin'
							target='_blank'
							rel='noopener noreferrer'>
							<img
								src='/assets/icons/1-solana-stable-meme-coin-x-twitter.png'
								alt='Twitter Icon'
								className='icon'
							/>
							Twitter/X
						</a>
					</div>
					<div className='link-item'>
						<a
							href='https://www.coingecko.com/en/coins/1-dollar-sol-coin'
							target='_blank'
							rel='noopener noreferrer'>
							<img
								src='/assets/icons/1-solana-stable-meme-coin-gecko.png'
								alt='CoinGecko Icon'
								className='icon'
							/>
							CoinGecko Link
						</a>
					</div>
					<div className='link-item'>
						<a
							href='https://dexscreener.com/solana/GUhiSjWhMjbd6aZuMkKnb8Yxqj9qytFoN4sKUM2hNePU'
							target='_blank'
							rel='noopener noreferrer'>
							<img
								src='/assets/icons/1-solana-stable-meme-coin-DEX-screener.png'
								alt='DEX Screener Icon'
								className='icon'
							/>
							DEX Screener
						</a>
					</div>
					<div className='link-item'>
						<em>
							<img
								src='/assets/icons/1-solana-stable-meme-coin-vaporwave.png'
								alt='Vaporwave Icon'
								className='icon'
							/>
							Discord Coming Soon
						</em>
					</div>
				</div>

				{/* About Content */}
				<div className='about-content-wrapper'>
					<div className='about-content'>
						<h2>What Is The $1 Project?</h2>
						<p>
							The $1 Project started as a memecoin on the Solana
							blockchain, launched on October 16, 2024. Its journey began
							on pump.fun and quickly transitioned into a community-driven
							initiative. Born from a vibrant community, The $1 Project
							aims to provide stability and value in a volatile memecoin
							market. Unlike typical memecoins, it combines real-world
							financial potential with engaging gamified elements. With a
							commitment to coexistence rather than competition, the
							project invites other memecoins to join forces, turning
							profits into a stable, reliable token ecosystem. At its
							heart, this project isn't just about numbers—it's about
							building something sustainable, funny, and fun.
						</p>

						<h3>The $1 Odyssey</h3>
						<p>
							Welcome to The $1 Odyssey—a parallel universe where the real
							world and gamified storytelling collide. This journey offers
							two distinct worlds: the real-world economy, where you can
							buy, sell, and stake tokens for tangible financial rewards,
							and the immersive narrative-driven universe, where anonymity
							and creativity reign. Here, players can participate in
							gamified narratives, build empires, and shape outcomes while
							experiencing real-world financial rewards. Whether you're
							tackling quests, trading in the real world, or exploring
							uncharted territories, The $1 Odyssey provides endless
							opportunities to create, earn, and grow. Together, we'll
							craft a thriving ecosystem that offers both excitement and
							real-world impact.
						</p>
					</div>
				</div>

				{/* Navigation Buttons */}
				<div className='navigation-wrapper'>
					<div className='choice-button-container'>
						<button
							className='choice-button'
							onClick={() => navigate('/')}>
							Back to Home
						</button>
						<button
							className='choice-button'
							onClick={() => navigate('/faq')}>
							Proceed to the{' '}
							<img
								src='/assets/images/solana_1_dollar_stable_memecoin_270x248px.png'
								alt='$1 Logo'
								className='logo'
							/>{' '}
							FAQ
						</button>
					</div>
				</div>
			</DigitalDisplay>
		</div>
	);
};

export default About;
